export default "__VITE_ASSET__55613608__"